module.exports = __webpack_public_path__ + "img/blue-circle.ed6a1531.svg";